module.exports = __webpack_public_path__ + "img/microsemi.7a66d97c.jpg";